/**
 * Helpers for the API error shape produced by `attachHttpStatusToError`
 * (see `errorInterceptor.ts`): plain objects with the HTTP status spread
 * in — not router ErrorResponses or Error instances.
 *
 * Kept import-free so page/form modules can use them without creating a
 * dependency cycle through the router.
 */

/** HTTP status attached to an API error, or `undefined` for any other shape. */
export const getApiErrorStatus = (error: unknown): number | undefined =>
  typeof error === 'object' &&
  error !== null &&
  'status' in error &&
  typeof error.status === 'number'
    ? error.status
    : undefined;

/**
 * `throwOnError` predicate for plain `useQuery` calls: rethrow API 404s
 * (e.g. a soft-deleted or missing policy, DC-3538) so the route error
 * boundary renders the not-found page instead of the tab rendering an
 * empty state. Other errors keep the query's local error handling.
 */
export const isApiNotFoundError = (error: unknown): boolean =>
  getApiErrorStatus(error) === 404;
